import React, { PureComponent } from 'react';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import { formatNumericHumanDate, parseNumericHumanDate } from '~/DateTime';
import DatePickerInput from '~/UI/DatePickerInput/DatePickerInput';
import defaultInputStyles from '~/UI/Input/compact.less';
import SaveActivityIndicator, { Status } from '~/UI/SaveActivityIndicator/SaveActivityIndicator';

import styles from './styles.less';

interface Props {
	group: UserProductGroup;
	updateStatus: Status | null;
	onUpdate(id: string, date: Date | null): void;
}

interface State {
	readonly historicProductDataViewDate: {
		readonly value: string;
		readonly date: Date | null;
	};
}

export default class Settings extends PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		const { historicProductDataViewDate } = props.group;
		this.state = {
			historicProductDataViewDate: {
				value: historicProductDataViewDate !== null ? formatNumericHumanDate(historicProductDataViewDate) : '',
				date: historicProductDataViewDate,
			},
		};
	}

	render() {
		const { updateStatus } = this.props;

		return (
			<div className={styles.container} data-testid='parameters-panel'>
				<div className={styles.content}>
					<div className={styles.parameters}>
						<p className={styles.parametersDescription}>Max price calculation parameters:</p>

						{this.renderHistoricViewDateInput()}
						<SaveActivityIndicator hideAfterMilliseconds={3000} status={updateStatus} />
					</div>
				</div>
			</div>
		);
	}

	private renderHistoricViewDateInput() {
		const { group, onUpdate } = this.props;
		const { historicProductDataViewDate } = this.state;

		const yearAgo = new Date();
		yearAgo.setDate(yearAgo.getDate() - 365 * 10);

		return (
			<label className={styles.parameterLabel} htmlFor='reference-historic-date'>
				<span className={styles.parameterLabelText}>Reference date:</span>
				<div className={styles.dateParameterInput}>
					<DatePickerInput
						clearable
						dateValue={historicProductDataViewDate.date}
						disabledDays={{ after: new Date(), before: yearAgo }}
						isInvalid={historicProductDataViewDate.value !== '' && historicProductDataViewDate.date === null}
						placeholder='Today'
						styles={defaultInputStyles}
						value={historicProductDataViewDate.value}
						onChange={(value) => {
							const date = value !== '' ? parseNumericHumanDate(value) : null;
							this.setState({ historicProductDataViewDate: { value, date } });
							if (date !== null || value === '') {
								onUpdate(group.id, date);
							}
						}}
					/>
				</div>
			</label>
		);
	}
}
